import isEmpty from 'lodash/isEmpty';
import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import {
  WIRFinalWIRSections,
  WIRInterventionCloseOutSections,
  WIRKofMeetingTechnicalWirSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getSectionSavingDisabled = (wir: WIR | null, section: string, country: string) => {
  switch (section) {
    case WIRKofMeetingTechnicalWirSections.signOffTechnicalWIR:
      if (country === CountryData.congo) {
        return (
          !isEmpty(wir?.signOffs?.technicalWirOriginator?.userId) &&
          /* istanbul ignore next */
          !isEmpty(wir?.signOffs?.technicalWirWscLeader?.userId)
        );
      } else {
        return (
          !isEmpty(wir?.signOffs?.technicalWirOriginator?.userId) &&
          /* istanbul ignore next */
          !isEmpty(wir?.signOffs?.technicalWirAssetRep?.userId) &&
          /* istanbul ignore next */
          !isEmpty(wir?.signOffs?.technicalWirInterventionEngineer?.userId)
        );
      }
    case WIRFinalWIRSections.finalWirSignOff:
      if (country === CountryData.congo) {
        return (
          !isEmpty(wir?.signOffs?.finalWirWscLeader?.userId) &&
          /* istanbul ignore next */
          !isEmpty(wir?.signOffs?.finalWirDwLead?.userId)
        );
      } else {
        return getIsUnplannedReactiveScope(wir)
          ? !isEmpty(wir?.signOffs?.finalWirAssetManager?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirWscLeader?.userId)
          /* istanbul ignore next */
          : !isEmpty(wir?.signOffs?.finalWirAssetManager?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirGsrManager?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirPerformanceLead?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirWscLeader?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirSiteSupportLeader?.userId) &&
              /* istanbul ignore next */
              !isEmpty(wir?.signOffs?.finalWirHeadOfReservoir?.userId);
      }
    case WIRInterventionCloseOutSections.hqTechnicalfinalInterventionSignOff:
      return country === CountryData.congo
        ? !isEmpty(wir?.signOffs?.dwManagementSignOff?.userId)
        : !isEmpty(wir?.signOffs?.interventionCloseOutFinalSignOff?.userId);
    default:
      return false;
  }
};
